/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M2 9H22M9 9L9 22M15 9L15 22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M2 9H22V15.6C22 17.8402 22 18.9603 21.564 19.816C21.1805 20.5686 20.5686 21.1805 19.816 21.564C18.9603 22 17.8402 22 15.6 22H8.4C6.15979 22 5.03969 22 4.18404 21.564C3.43139 21.1805 2.81947 20.5686 2.43597 19.816C2 18.9603 2 17.8402 2 15.6V9Z"
				fill="currentColor"
			/>
			<path
				d="M2 9H22M9 9L9 22M15 9L15 22M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.85 10.75C2.28995 10.75 2.00992 10.75 1.79601 10.859C1.60785 10.9549 1.45487 11.1078 1.35899 11.296C1.25 11.5099 1.25 11.7899 1.25 12.35V17.75C1.25 20.5114 3.48858 22.75 6.25 22.75C6.80229 22.75 7.25 22.3023 7.25 21.75L7.25 12.35C7.25 11.7899 7.25 11.5099 7.14101 11.296C7.04513 11.1078 6.89215 10.9549 6.70399 10.859C6.49008 10.75 6.21005 10.75 5.65 10.75H2.85ZM15.25 21.15C15.25 21.7101 15.25 21.9901 15.141 22.204C15.0451 22.3922 14.8922 22.5451 14.704 22.641C14.4901 22.75 14.2101 22.75 13.65 22.75H10.35C9.78995 22.75 9.50992 22.75 9.29601 22.641C9.10785 22.5451 8.95487 22.3922 8.85899 22.204C8.75 21.9901 8.75 21.7101 8.75 21.15L8.75 12.35C8.75 11.7899 8.75 11.5099 8.85899 11.296C8.95487 11.1078 9.10785 10.9549 9.29601 10.859C9.50992 10.75 9.78995 10.75 10.35 10.75H13.65C14.2101 10.75 14.4901 10.75 14.704 10.859C14.8922 10.9549 15.0451 11.1078 15.141 11.296C15.25 11.5099 15.25 11.7899 15.25 12.35L15.25 21.15ZM16.75 21.75C16.75 22.3023 17.1977 22.75 17.75 22.75C20.5114 22.75 22.75 20.5114 22.75 17.75V12.35C22.75 11.7899 22.75 11.5099 22.641 11.296C22.5451 11.1078 22.3922 10.9549 22.204 10.859C21.9901 10.75 21.7101 10.75 21.15 10.75H18.35C17.7899 10.75 17.5099 10.75 17.296 10.859C17.1078 10.9549 16.9549 11.1078 16.859 11.296C16.75 11.5099 16.75 11.7899 16.75 12.35L16.75 21.75ZM16 9.25H21.4167C21.7267 9.25 21.8817 9.25 22.0088 9.21593C22.3539 9.12346 22.6235 8.85391 22.7159 8.50882C22.75 8.38165 22.75 8.22666 22.75 7.91667C22.75 6.36671 22.75 5.59174 22.5796 4.9559C22.1173 3.23044 20.7696 1.88271 19.0441 1.42037C18.4083 1.25 17.6333 1.25 16.0833 1.25H7.91667C6.36671 1.25 5.59174 1.25 4.9559 1.42037C3.23044 1.88271 1.88271 3.23044 1.42037 4.9559C1.25 5.59174 1.25 6.36671 1.25 7.91667C1.25 8.22666 1.25 8.38165 1.28407 8.50882C1.37654 8.85391 1.64609 9.12346 1.99118 9.21593C2.11835 9.25 2.27334 9.25 2.58333 9.25H8H16Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M6 9H9M9 9H15M9 9V18M15 9H22V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14V10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005M15 9V18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2 9H9M9 9H15M9 9L9 22M15 9H22M15 9L15 22M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.85 10.75C2.28995 10.75 2.00992 10.75 1.79601 10.859C1.60785 10.9549 1.45487 11.1078 1.35899 11.296C1.25 11.5099 1.25 11.7899 1.25 12.35V17.75C1.25 20.5114 3.48858 22.75 6.25 22.75C6.80229 22.75 7.25 22.3023 7.25 21.75L7.25 12.35C7.25 11.7899 7.25 11.5099 7.14101 11.296C7.04513 11.1078 6.89215 10.9549 6.70399 10.859C6.49008 10.75 6.21005 10.75 5.65 10.75H2.85ZM15.25 21.15C15.25 21.7101 15.25 21.9901 15.141 22.204C15.0451 22.3922 14.8922 22.5451 14.704 22.641C14.4901 22.75 14.2101 22.75 13.65 22.75H10.35C9.78995 22.75 9.50992 22.75 9.29601 22.641C9.10785 22.5451 8.95487 22.3922 8.85899 22.204C8.75 21.9901 8.75 21.7101 8.75 21.15L8.75 12.35C8.75 11.7899 8.75 11.5099 8.85899 11.296C8.95487 11.1078 9.10785 10.9549 9.29601 10.859C9.50992 10.75 9.78995 10.75 10.35 10.75H13.65C14.2101 10.75 14.4901 10.75 14.704 10.859C14.8922 10.9549 15.0451 11.1078 15.141 11.296C15.25 11.5099 15.25 11.7899 15.25 12.35L15.25 21.15ZM16.75 21.75C16.75 22.3023 17.1977 22.75 17.75 22.75C20.5114 22.75 22.75 20.5114 22.75 17.75V12.35C22.75 11.7899 22.75 11.5099 22.641 11.296C22.5451 11.1078 22.3922 10.9549 22.204 10.859C21.9901 10.75 21.7101 10.75 21.15 10.75H18.35C17.7899 10.75 17.5099 10.75 17.296 10.859C17.1078 10.9549 16.9549 11.1078 16.859 11.296C16.75 11.5099 16.75 11.7899 16.75 12.35L16.75 21.75Z"
				fill="currentColor"
			/>
			<path
				d="M21.4167 9.25H16H8H2.58333C2.27334 9.25 2.11835 9.25 1.99118 9.21593C1.64609 9.12346 1.37654 8.85391 1.28407 8.50882C1.25 8.38165 1.25 8.22666 1.25 7.91667C1.25 6.36671 1.25 5.59174 1.42037 4.9559C1.88271 3.23044 3.23044 1.88271 4.9559 1.42037C5.59174 1.25 6.36671 1.25 7.91667 1.25H16.0833C17.6333 1.25 18.4083 1.25 19.0441 1.42037C20.7696 1.88271 22.1173 3.23044 22.5796 4.9559C22.75 5.59174 22.75 6.36671 22.75 7.91667C22.75 8.22666 22.75 8.38165 22.7159 8.50882C22.6235 8.85391 22.3539 9.12346 22.0088 9.21593C21.8817 9.25 21.7267 9.25 21.4167 9.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
